export const DATA_POINTS_FREQUENCY = {
  DAILY: 'DAILY',
  WEEKLY: 'WEEKLY',
  MONTHLY: 'MONTHLY',
  QUARTERLY: 'QUARTERLY',
  WEEKLY_STARTING_MONDAY: 'WEEKLY_STARTING_MONDAY'
};
export const FREQUENCY_OPTIONS = [DATA_POINTS_FREQUENCY.DAILY, DATA_POINTS_FREQUENCY.WEEKLY, DATA_POINTS_FREQUENCY.WEEKLY_STARTING_MONDAY, DATA_POINTS_FREQUENCY.MONTHLY, DATA_POINTS_FREQUENCY.QUARTERLY];
export const ASSET_TYPES = {
  WEB_INTERACTIVES: 'WEB_INTERACTIVES'
};